import { AlertTriangle } from "lucide-react";
import { friendlyRange } from "./client-detail/compare/headlineTotals";

// Asks which dates to use when a PDF's own dates differ from the picked import dates
export const DateMismatchDialog = ({ check }) => {
  if (!check) return null;
  const { report, picked, resolve } = check;
  return (
    <div className="fixed inset-0 z-[130] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="date-mismatch-dialog">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <div className="flex items-center gap-2 mb-2">
          <AlertTriangle className="w-5 h-5 text-amber-500" />
          <p className="text-base font-bold text-slate-900">These dates don't match</p>
        </div>
        <p className="text-sm text-slate-600 mb-5">
          The report says <b>{friendlyRange(report.start, report.end)}</b>, but the import dates are set to <b>{friendlyRange(picked.start, picked.end)}</b>. Which should this upload use?
        </p>
        <div className="flex flex-col gap-2">
          <button onClick={() => resolve(report)} className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold" data-testid="date-mismatch-use-report">
            Use the report's dates ({friendlyRange(report.start, report.end)})
          </button>
          <button onClick={() => resolve(picked)} className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 text-sm" data-testid="date-mismatch-keep-picked">
            Keep my dates ({friendlyRange(picked.start, picked.end)})
          </button>
          <button onClick={() => resolve(null)} className="px-4 py-2 text-slate-500 hover:text-slate-700 text-xs" data-testid="date-mismatch-cancel">Cancel upload</button>
        </div>
      </div>
    </div>
  );
};

export default DateMismatchDialog;
